import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/accusoft': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M482.2 372.1C476.5 365.2 250 75 242.3 65.5 228.6 48.3 242.3 48.7 261.5 48.6 271.2 48.5 367.8 48 378 48 402.1 47.9 406.7 48.6 416.4 60.8 418.5 63.5 621.5 306.6 623.6 309.1 629.1 315.8 638.8 328.2 630.8 332.5 628.4 333.8 516.2 380.2 513 381.4 502.9 385.4 495.5 388.2 482.2 372.1M596.9 366.5S481.9 416.9 479.4 418.1C463.4 425.4 452.5 414.9 442.7 403.5L385.6 329.5C380.2 328.6 325.2 319.9 320.3 320.2 317.2 320.4 310.7 321 305.9 323.1 301 325.2 160.7 375.9 155.7 377.8 150.6 379.8 144.3 381.4 144.6 385.4 144.8 387.9 146.6 388 149.2 388.9 151.9 389.7 450.1 456.5 457.2 458 472.8 461.3 495.7 468.5 510.8 459.7 512.9 458.5 634.6 383.3 636.6 381.9 642 377.9 640.9 375.1 634.9 373.7 632.6 373.4 610.3 369 596.9 366.5M270.9 185.2S258.9 186.8 245.9 200.3C236.9 209.6 3.8 439.4 2.5 441.2-4.5 451.2 4.1 448 18.2 442.9 19 442.9 132.7 406.3 132.7 406.3 133.2 405.7 132.6 406.2 133.3 405.7 132.9 400.6 132.5 379.5 132.3 378 131.7 372.8 134.5 371.1 139.3 369.1L231.9 335.3C232.5 334.5 320.4 253.6 322.1 252V251L270.9 185.2'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/accusoft.js
// module id = 9juE
// module chunks = 144